"use client";

import { c as _c } from "react/compiler-runtime";
import { extractErrorCode } from "@local/error/src/extractErrorCode";
import { useTransition } from "react";
interface ErrorPageProps {
  error: Error & {
    digest?: string;
    code?: string;
  };
  /**
   * Next's `retry`, not `reset`. `reset()` only clears boundary state and
   * re-renders, so it cannot recover a Server Component error — which is what
   * nearly every error reaching this page is (an Offer API failure). `retry()`
   * re-fetches the segment. Stable since Next 16.3.
   */
  retry: () => void;
  heading?: string;
}
export const ErrorPage = t0 => {
  const $ = _c(24);
  const {
    error,
    retry,
    heading: t1
  } = t0;
  const heading = t1 === undefined ? "Something went wrong" : t1;
  const [isRetrying, startRetry] = useTransition();
  let t2;
  if ($[0] !== error) {
    t2 = extractErrorCode(error) ?? "STORE-X001";
    $[0] = error;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const errorCode = t2;
  let t3;
  if ($[2] !== error.digest) {
    t3 = error.digest?.slice(0, 8).toUpperCase();
    $[2] = error.digest;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const refCode = t3;
  let t4;
  if ($[4] !== heading) {
    t4 = <h5 className="text-h5 leading-heading mb-4 font-semibold">{heading}</h5>;
    $[4] = heading;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="mb-2 text-gray-600">We encountered an unexpected error. Please try again.</p>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== errorCode) {
    t6 = <p>Error: {errorCode}</p>;
    $[7] = errorCode;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== refCode) {
    t7 = refCode && <p>Reference: {refCode}</p>;
    $[9] = refCode;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="mb-6 space-y-1 font-mono text-xs text-gray-400">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== retry) {
    t9 = () => startRetry(() => retry());
    $[14] = retry;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = isRetrying ? "Retrying\u2026" : "Try again";
  let t11;
  if ($[16] !== isRetrying || $[17] !== t10 || $[18] !== t9) {
    t11 = <button type="button" onClick={t9} disabled={isRetrying} aria-label="Try loading the page again" className="min-h-11 rounded-full bg-gray-900 px-6 py-2 text-white transition-colors hover:bg-gray-700 focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-40 sm:min-h-[50px]">{t10}</button>;
    $[16] = isRetrying;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t4 || $[22] !== t8) {
    t12 = <div role="alert" id="error-page" className="flex min-h-[50vh] flex-col items-center justify-center px-4 text-center">{t4}{t5}{t8}{t11}</div>;
    $[20] = t11;
    $[21] = t4;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};